var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("0.2.0-Thu Mar 03 2022 15:48:09 GMT+0530 (India Standard Time)")])}
var staticRenderFns = []

export { render, staticRenderFns }